import React, { useState, useEffect } from 'react';

function ImageGallery({ product, initialIndex = 0, onClose, lang }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    const handleArrowLeft = (e) => {
      if (e.key === 'ArrowLeft') {
        prevImage();
      }
    };

    const handleArrowRight = (e) => {
      if (e.key === 'ArrowRight') {
        nextImage();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.addEventListener('keydown', handleArrowLeft);
    document.addEventListener('keydown', handleArrowRight);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('keydown', handleArrowLeft);
      document.removeEventListener('keydown', handleArrowRight);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, currentIndex]);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % product.images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? product.images.length - 1 : prev - 1
    );
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="gallery-overlay" onClick={handleBackdropClick}>
      <div className="gallery-container">
        <button className="gallery-close" onClick={onClose}>
          ✕
        </button>

        <div className="gallery-header">
          <h3 className="gallery-title">{product.name[lang]}</h3>
          <p className="gallery-subtitle">Модель: {product.model}</p>
        </div>

        <div className="gallery-main">
          <button className="gallery-arrow gallery-arrow-left" onClick={prevImage}>
            ‹
          </button>

          <div className="gallery-image-container">
            <img
              src={product.images[currentIndex]}
              alt={`${product.name[lang]} - ${currentIndex + 1}`}
              className="gallery-image"
            />
            <div className="gallery-counter">
              {currentIndex + 1} / {product.images.length}
            </div>
          </div>

          <button className="gallery-arrow gallery-arrow-right" onClick={nextImage}>
            ›
          </button>
        </div>

        <div className="gallery-thumbnails">
          {product.images.map((image, index) => (
            <button
              key={index}
              className={`gallery-thumbnail ${
                index === currentIndex ? 'active' : ''
              }`}
              onClick={() => setCurrentIndex(index)}
            >
              <img src={image} alt={`Thumbnail ${index + 1}`} />
            </button>
          ))}
        </div>

        <div className="gallery-info">
          <div className="gallery-specs">
            <div className="spec-row">
              <span className="spec-label">Мощность:</span>
              <span className="spec-value">{product.power}</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Площадь обогрева:</span>
              <span className="spec-value">{product.area}</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Размеры:</span>
              <span className="spec-value">{product.size}</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Материалы:</span>
              <span className="spec-value">{product.materials[lang]}</span>
            </div>
          </div>

          <div className="gallery-actions">
            <span className="gallery-price">{product.price}</span>
            <a href="tel:+39 379 227 5566" className="btn btn-primary">
              {lang === 'it' ? 'Ordina per telefono' : 'Заказать по телефону'}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageGallery;
